<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Nova Entrada de Nota Fiscal
      </p>
    </div>

    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
        ></lista-unidades-select>
      </div>

      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Centro de Custo</div>

        <SelectCentroCustos
          class="input-new-design"
          v-model="filtros.centroCustoId"
        />
      </div>
    </div>
    <div
      class="row text-brand-5 text-weight-bold q-gutter-x-sm container-input-file"
    >
      <div style="margin-top: 31px" class="row align-center container">
        <q-file
          class="input-new-design"
          v-model="file"
          style="border-radius: 8px; min-width: 245px; max-width: 245px"
          label="Selecione o XML"
          @change="onFileSelected"
          id="arquivo"
          dense
          outlined
        >
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
          <template v-slot:append>
            <q-icon
              v-if="file !== null"
              name="close"
              @click.stop.prevent="file = null"
              class="cursor-pointer"
            />
          </template>
        </q-file>

        <div
          style="font-size: 16px; font-weight: 100"
          class="text-brand-1 q-ml-sm"
        >
          {{ file ? file.name : "Nenhum arquivo selecionado" }}
        </div>
      </div>
    </div>
    <div class="btn-gerar-container">
      <q-btn
        class="q-mt-md"
        icon="add"
        label="Gerar Entrada"
        style="background-color: #21324a; border-radius: 8px; color: white"
        no-caps
        @click="gerarEntrada()"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelectCentroCustos from "../../../legado/compras/components/SelectCentroCustos.vue";
export default {
  components: { ListaUnidadesSelect, SelectCentroCustos },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const tenentsSemCentro = ref({
      pg: false,
      "staging-pg": false,
    });
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const filtros = ref({
      busca: "",
      centroCustoId: "",
    });
    const listaCentroCustos = ref([]);
    let loadingInner = ref(false);
    let file = ref(null);
    const xmlUrl = ref("");

    const listarCentrosDeCustos = async () => {
      try {
        loadingInner.value = true;
        const response = await store.dispatch(
          "notaFiscal/listarCentrosCustos",
          {
            vendor_id: unidade.value.id,
            per_page: 20,
            search: filtros.value.busca,
          }
        );
        listaCentroCustos.value = response.data.results.data;
        loadingInner.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    const gerarEntrada = async () => {
      if (file.value == null) {
        quasar.notify({
          message: "Selecione um xml para gerar a entrada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (file.value.type != "text/xml") {
        quasar.notify({
          message: "O arquivo precisa ser um xml",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      if (
        tenentsSemCentro.value[store.state.autenticacao.cliente[0]] ==
          undefined &&
        filtros.value.centroCustoId == ""
      ) {
        quasar.notify({
          message: "Selecione um centro de custo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("notaFiscal/gerarEntrada", {
          vendor_id: unidade.value.id,
          cost_center_id: filtros.value.centroCustoId?.id,
          nota_fiscal: xmlUrl.value,
        });
        let notaId = response.data.model.id;
        quasar.notify({
          message:
            "Nota criada com sucesso, edite os códigos e entradas para finalizar!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "nf-editar", params: { notaId: notaId } });
        filtros.value.centroCustoId = "";
        file.value = null;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar nota",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarCentrosDeCustos();
      }
    );

    watch(
      () => filtros.value.busca,
      () => {
        listarCentrosDeCustos();
      }
    );

    watch(
      () => file.value,
      () => {
        if (file.value != null) {
          let fileReader = new FileReader();

          fileReader.readAsDataURL(file.value);
          fileReader.addEventListener("load", () => {
            xmlUrl.value = fileReader.result;
          });
        }
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    const backPage = async () => {
      router.back();
    };

    onMounted(getUnidade);

    onMounted(listarCentrosDeCustos);

    return {
      unidade,
      listarCentrosDeCustos,
      listaCentroCustos,
      filtros,
      loadingInner,
      onFileSelected,
      file,
      xmlUrl,
      gerarEntrada,
      backPage,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.align-center {
  align-items: center;
}
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
  cursor: pointer;
  border-color: #2196f3;
  color: #58afc1;
}
.info {
  border-color: #58afc1;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: -2px;
  left: 9px;
}
.texto-titulo-input {
  color: #21324a !important;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
    color: #21324a !important;
  }
  .container-input-file {
    margin: 5px 0px 0px 0px;
  }
  .btn {
    border: 2px solid black;
    background-color: white;
    color: black;
    border-radius: 5px;
    margin: 0px 5px 0 0;
    padding: 4px 6px;
    padding-left: 40px;
    cursor: pointer;
    border-color: #2196f3;
    color: #58afc1;
    font-size: 12px;
  }
  .info {
    border-color: #58afc1;
  }
  .text {
    display: inline;
    font-size: 8px;
    display: none;
  }
  .container {
    position: relative;
  }
  .icon {
    position: absolute;
    top: -2px;
    left: 9px;
  }
  .btn-gerar-entrada {
    font-size: 12px;
  }
  .btn-gerar-container {
    margin: 8px 0px 0px 9px;
  }
  .select {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .container-centro-custo {
    margin: 50px 0px 0px 0px;
  }
  .radio-centro {
    font-size: 12px;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
